// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"styles_searchBox__Mgjzq","mobileSearchBox":"styles_mobileSearchBox__3qg0e","searchInput":"styles_searchInput__y4Duh"};